module.exports = __webpack_public_path__ + "static/img/usc_marshall_footer_logo.c24a552.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/usc_marshall_footer_logo.svg
// module id = mHj9
// module chunks = 1